export const getInquiryForm = [
    {
        name: 'firstname',
        label: 'Name',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'lastname',
        label: 'Surname',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'email',
        label: 'Email',
        translateLabel: false,
        type: 'text'
    },
    {
        name: 'phoneNumber',
        label: 'Phone Number',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'vehicleId',
        label: 'Model of interest',
        translateLabel: true,
        type: 'dropdown'
    },
    {
        name: 'documentTypeId',
        label: 'Document Type',
        translateLabel: true,
        type: 'dropdown'
    },
    {
        name: 'documentNumber',
        label: 'documentNumber',
        translateLabel: true,
        type: 'text'
    },
    {
        name: 'showroomId',
        label: 'Preferred dealer',
        translateLabel: true,
        type: 'dropdown'
    },
    {
        name: 'comments',
        label: 'Comments',
        translateLabel: true,
        type: 'textArea'
    }
];